import { loadContentRegistry } from '../data';

export const COMBAT_VISUAL_LIMITS = Object.freeze({
  particlesPerEmitter: 64,
  rewardParticles: 128,
  trackedProjectiles: 128,
  segments: 192,
  segmentSeconds: 0.18,
  deathImages: 24,
  deathSeconds: 0.3,
  pendingChainHits: 64
});

export const GameConfig = {
  getRuntimeDefaults() {
    const settings = loadContentRegistry().getGameSettings();
    return {
      bossSpawnTime: settings.bossSpawnTime,
      killBossToWin: settings.killBossToWin,
      bossesToWin: settings.bossesToWin
    } as const;
  }
} as const;
